import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';

import { BookingService, BookingStore } from '@store';

@Component({
  selector: 'app-booking-contingent-subscriptions-checkout',
  templateUrl: './booking-contingent-subscriptions-checkout.component.html',
  styleUrls: ['./booking-contingent-subscriptions-checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingContingentSubscriptionsCheckoutComponent implements OnDestroy {
  @Input() invoiceNumber: string;
  @Output() back = new EventEmitter<void>();

  constructor(public bookingStore: BookingStore, public bookingService: BookingService) {}

  onContinue(): void {
    this.bookingStore.subscribePackage(this.invoiceNumber);
  }

  onBack(): void {
    this.back.emit();
  }

  ngOnDestroy(): void {
    this.bookingStore.resetSubscriptionsDetails();
  }
}
